import React from "react";
import {usePersonTypeOptions} from "utils/hooks/usePersonTypeOptions";
import {PersonType} from "types/enums/PersonType";
import AccessTicketDriversAssignUserButton from "./AccessTicketDriversAssignUserButton";
import FeatherIcon from "components/FeatherIcon";

const PresetPersonTypeOption = (props: {option: PersonType; onClick: (opt: boolean) => void}) => {
    const {getOption} = usePersonTypeOptions();

    const generatedOption = getOption(props.option);
    const description = generatedOption.description;

    return (
        <AccessTicketDriversAssignUserButton
            backIcon={<FeatherIcon name={"plus-circle"} className={"size-[20px] md:size-[30px]"} strokeWidth={2} />}
            className={"PresetPersonTypeOption"}
            frontIcon={generatedOption.icon}
            onClick={() => props.onClick(props.option === PersonType.Adult)}
            secondRowChildren={description}
        >
            <span className={"grow font-medium text-left py-3 text-sm md:text-base"}>{generatedOption.label}</span>
        </AccessTicketDriversAssignUserButton>
    );
};

export default PresetPersonTypeOption;
